var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFoundationIconsVehiclesPickupPickupMd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "kh35rqlx3a",
    colorInterpolationFilters: "auto"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.000000 0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#kh35rqlx3a)",
    transform: "translate(-518.000000, -642.000000) translate(210.000000, 112.000000) translate(40.000000, 126.000000) translate(0.000000, 154.000000) translate(4.000000, 234.000000) translate(240.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 1.467,
    transform: "translate(24.000000, 16.000000) translate(1.000000, 6.500000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6,
    cy: 11.556,
    rx: 1.467,
    ry: 1.444
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.867,
    cy: 11.556,
    rx: 1.467,
    ry: 1.444
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.067 11.556h1.466c.81 0 1.467-.647 1.467-1.445V8.667c0-1.596-1.313-2.89-2.933-2.89H17.6L15.072.799C14.824.308 14.316 0 13.76 0h-3.493C9.457 0 8.8.647 8.8 1.444v4.334H1.467C.657 5.778 0 6.424 0 7.222v2.89c0 .797.657 1.444 1.467 1.444H4.4M16.133 11.556L7.333 11.556M8.8 5.778L17.6 5.778"
  }))))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoundationIconsVehiclesPickupPickupMd);
export default __webpack_public_path__ + "static/media/foundation-icons-vehicles-pickup-pickup-md.6698c9dce2142a2c73f1b78359918620.svg";
export { ForwardRef as ReactComponent };